// extracted by mini-css-extract-plugin
export default {"HeaderVector":"HeaderView_HeaderVector__Nb4hV","TopIntro":"HeaderView_TopIntro__SxgeP","CenterArea":"HeaderView_CenterArea__NoAWh","TopPizza":"HeaderView_TopPizza__LVwRa"};